import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20 max-w-6xl" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 text-sm text-red-600"
}
const _hoisted_3 = { class: "mb-8 rounded-xl border border-catering-cream-300 bg-catering-cream-100 px-6 py-5" }
const _hoisted_4 = { class: "flex items-start gap-4" }
const _hoisted_5 = {
  class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-catering-md bg-gradient-to-br from-catering-lemon to-catering-lemon-300 shadow-catering-xs",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "mt-4 grid gap-3 sm:grid-cols-3" }
const _hoisted_7 = { class: "flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-catering-ink-900 text-[11px] font-semibold text-catering-lemon" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = { class: "block text-sm font-medium text-gray-900" }
const _hoisted_10 = { class: "block text-xs text-gray-500" }
const _hoisted_11 = { class: "grid items-start gap-6 px-6 pb-6 pt-5 xl:grid-cols-[minmax(0,1fr)_420px] xl:gap-7" }
const _hoisted_12 = {
  key: 1,
  "data-question-editor": "",
  class: "rounded-[10px] border border-gray-300 bg-gray-50 p-4"
}
const _hoisted_13 = { class: "grid gap-3 sm:grid-cols-2" }
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "mt-3 text-xs text-amber-700"
}
const _hoisted_19 = { class: "mt-4 flex items-center gap-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "rounded-[10px] border border-dashed border-gray-300 px-5 py-8 text-center"
}
const _hoisted_22 = { class: "mt-4 flex justify-center gap-2" }
const _hoisted_23 = { class: "mt-5 rounded-[10px] border border-dashed border-gray-300 bg-gray-50 px-3.5 py-3" }
const _hoisted_24 = { class: "mt-2 divide-y divide-gray-200" }
const _hoisted_25 = { class: "min-w-0 flex-1" }
const _hoisted_26 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_27 = { class: "mt-px text-xs text-gray-500" }
const _hoisted_28 = { class: "shrink-0 whitespace-nowrap pt-0.5 text-xs text-gray-500" }

import { LockClosedIcon, XMarkIcon } from '@heroicons/vue/20/solid'
import { GlobeAltIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import InputField from '@/components/neue/InputField.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import SettingCard from '@/components/settings/SettingCard.vue'
import SettingRow from '@/components/settings/SettingRow.vue'
import { useAgentSections, websiteReportPath } from '@/composables/useAgentSections'
import { isSelect, TYPE_OPTIONS, typeLabel, useWebsiteEmbed } from '@/composables/useWebsiteEmbed'
import { useRevealed } from '@/helpers/revelio'
import api from '@/store/api'
import { mapRelationship, mapTypeIncludingInactive } from '@/store/mappers'

import { cateringAgentTitle } from './agentTypes'
import ChannelDesigner from './ChannelDesigner.vue'
import ChannelReportLink from './ChannelReportLink.vue'
import EmbedPreview from './EmbedPreview.vue'
import { formTestBody, openTestPage, testPageCard, testPageDocument } from './embedTestPage'
import QuestionCard from './QuestionCard.vue'
import RequiredSwitch from './RequiredSwitch.vue'
import SiteMini from './SiteMini.vue'
import WebsiteChannel from './WebsiteChannel.vue'
import { CHAT_COLOR_ELEMENTS, FORM_COLOR_ELEMENTS } from './websiteColors'

// The form goes on one specific page; the chat goes once, site-wide.

export default {
  __name: 'AgentWebsite',
  setup(__props) {

const FORM_PASTE_GUIDES = [
  { platform: 'Squarespace', steps: 'Pages \u2192 your page \u2192 Add block \u2192 Code' },
  { platform: 'Wix', steps: 'Settings \u2192 Custom Code \u2192 Add code to Body' },
  { platform: 'WordPress', steps: 'Edit page \u2192 add a Custom HTML block' }
]

const CHAT_PASTE_GUIDES = [
  { platform: 'Squarespace', steps: 'Settings \u2192 Advanced \u2192 Code Injection \u2192 Footer' },
  { platform: 'Wix', steps: 'Settings \u2192 Custom Code \u2192 Add code to Body' },
  { platform: 'WordPress', steps: 'Appearance \u2192 Theme File Editor, or a footer scripts plugin' }
]

const INTRO_STEPS = [
  { title: 'Switch one on', body: 'The form, the chat, or both.' },
  { title: 'Make it yours', body: 'Set the questions, colors and wording. It saves as you go.' },
  { title: 'Embed it', body: 'Copy the code into your site.' }
]

const FORM_BENEFITS = [
  'Sits inside a page, wherever you paste it',
  'Best on a Catering or Contact page',
  'Asks everything up front, in one go'
]

const CHAT_BENEFITS = [
  'Follows the visitor on every page',
  "Catches people who wouldn't fill in a form",
  'Asks one question at a time'
]

const FORM_TEXTS = [
  { field: 'title', label: 'Title', align: 'title' },
  { field: 'description', label: 'Subtitle', align: 'description' },
  { field: 'submit_button_text', label: 'Button', align: 'button' }
]

const CHAT_TEXTS = [
  { field: 'chat_subtitle', label: 'Title' },
  { field: 'chat_title', label: 'Subtitle' }
]

const EXAMPLE_BLURB = {
  form: 'the form is on it twice: at full height, then inside a 600px box.',
  chat: 'the chat bubble is in the bottom corner.'
}

const route = useRoute()
const store = useStore()

const agentSections = useAgentSections()
const testPageRevealed = useRevealed()

const {
  form,
  fields,
  editingKey,
  rows,
  questionList,
  websiteAttrs,
  savedFormEnabled,
  savedChatEnabled,
  colorDefaults,
  wordingDefaults,
  formPreview,
  chatPreview,
  syncing,
  saveError,
  load: loadWebsite,
  addStarterQuestions,
  addField,
  removeField,
  applyEdit,
  isComplete,
  reset
} = useWebsiteEmbed(() => `agents/${route.params.id}/website`)

const loading = ref(true)
const reportSummary = ref(null)

const agent = computed(() => mapTypeIncludingInactive('agent').find(a => a.id === route.params.id))
const playbook = computed(() => mapRelationship(agent.value?.relationships?.agent_playbook?.data))
const agentActive = computed(() => agent.value?.attributes?.is_active !== false)

const pendingNotes = computed(() =>
  agentActive.value
    ? { form: "Your form isn't taking inquiries yet.", chat: "Your chat widget isn't taking inquiries yet." }
    : {
        form: "Your catering agent is switched off, so your form isn't taking inquiries.",
        chat: "Your catering agent is switched off, so your chat widget isn't taking inquiries."
      }
)

const businessName = computed(() => {
  const merchant = store.state.loggedInUser?.attributes ?? {}
  return merchant.user_name || merchant.handle || ''
})

const headerText = computed(() => cateringAgentTitle(playbook.value?.attributes?.store_name))

// Phone and consent are rendered by the embed unconditionally and enforced
// server-side, so they are shown here as a fixed group rather than as questions.
const FIXED_FIELDS = computed(() => [
  { label: 'Phone number', type: 'Phone', meta: 'Where your agent texts them.' },
  { label: 'SMS consent', type: 'Checkbox', meta: null }
])

const fixedMeta = fixed => fixed.meta || websiteAttrs.value.consent_text || ''

const loadAgent = () => api.call('GET', `agents/${route.params.id}?included=agent_playbook`)

const exampleBody = (channel, snippet) =>
  channel === 'chat'
    ? testPageCard('Get in touch', 'Ask us anything using the chat bubble.', snippet)
    : formTestBody({ snippet, heading: 'Get in touch', blurb: "Tell us about your event and we'll text you back." })

const openExample = channel => {
  const snippet = channel === 'chat' ? websiteAttrs.value.chat_embed_snippet : websiteAttrs.value.form_embed_snippet
  if (!snippet) return

  openTestPage(
    testPageDocument({
      body: exampleBody(channel, snippet),
      blurb: EXAMPLE_BLURB[channel],
      strapline: 'Catering inquiries'
    })
  )
}

const loadReportSummary = () =>
  api
    .call('GET', `agents/${route.params.id}/website/report_summary`)
    .then(response => {
      reportSummary.value = response?.data ?? null
    })
    .catch(() => {
      reportSummary.value = null
    })

onMounted(() => {
  Promise.all([loadAgent(), loadWebsite()])
    .then(reset)
    .finally(() => {
      loading.value = false
    })
  loadReportSummary()
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, {
        text: headerText.value,
        sections: _unref(agentSections),
        "save-status": true
      }, null, 8, ["text", "sections"])
    ]),
    main: _withCtx(() => [
      _createVNode(NeueLoading, { loading: loading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(saveError))
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(saveError)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_unref(GlobeAltIcon), { class: "h-5 w-5 text-catering-ink-900" })
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "min-w-0" }, [
                  _createElementVNode("h2", { class: "text-base font-semibold text-gray-900" }, "Turn website visitors into catering leads"),
                  _createElementVNode("p", { class: "mt-1 text-sm text-gray-600" }, " Two ways to catch a lead on your own site. Both ask the questions below and hand the answers to your catering agent, which texts the customer back. ")
                ], -1))
              ]),
              _createElementVNode("ol", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(INTRO_STEPS, (step, index) => {
                  return _createElementVNode("li", {
                    key: step.title,
                    class: "flex items-start gap-2.5 rounded-lg bg-white/80 px-3 py-2.5 ring-1 ring-catering-cream-300"
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(index + 1), 1),
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(step.title), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(step.body), 1)
                    ])
                  ])
                }), 64))
              ])
            ]),
            _createVNode(WebsiteChannel, {
              enabled: _unref(form).enabled,
              "onUpdate:enabled": _cache[2] || (_cache[2] = $event => ((_unref(form).enabled) = $event)),
              name: "Inquiry form",
              description: "A form on your page. Someone fills it in and your agent texts them to start the conversation.",
              live: _unref(savedFormEnabled),
              syncing: _unref(syncing),
              snippet: _unref(websiteAttrs).form_embed_snippet,
              "paste-guides": FORM_PASTE_GUIDES,
              "can-try": _unref(testPageRevealed),
              "customize-label": "Preview and customize form",
              benefits: FORM_BENEFITS,
              "embed-label": "How to embed the form in your site",
              "sizing-note": "The form stretches to fill whatever it sits in. Put the code inside a container on your page and give that container the width or height you want. If it's shorter than the form, the questions scroll and the title stays in view.",
              "paste-note": "The form shows up wherever you paste it. Paste it once per page.",
              "manual-note": "Paste this into the page's HTML where you want the form to appear.",
              "pending-note": pendingNotes.value.form,
              "off-note": "Your form is switched off, so nobody can send an inquiry.",
              onTry: _cache[3] || (_cache[3] = $event => (openExample('form')))
            }, {
              mini: _withCtx(() => [
                _createVNode(SiteMini, {
                  channel: "form",
                  config: _unref(formPreview),
                  "site-name": businessName.value
                }, null, 8, ["config", "site-name"])
              ]),
              report: _withCtx(() => [
                _createVNode(ChannelReportLink, {
                  summary: reportSummary.value?.form,
                  days: reportSummary.value?.days,
                  to: _unref(websiteReportPath)(_unref(route).params.id, 'form')
                }, null, 8, ["summary", "days", "to"])
              ]),
              customize: _withCtx(() => [
                _createVNode(ChannelDesigner, {
                  colors: _unref(form).form_colors,
                  "onUpdate:colors": _cache[0] || (_cache[0] = $event => ((_unref(form).form_colors) = $event)),
                  alignment: _unref(form).form_alignment,
                  "onUpdate:alignment": _cache[1] || (_cache[1] = $event => ((_unref(form).form_alignment) = $event)),
                  channel: "form",
                  "script-url": _unref(websiteAttrs).form_embed_script_url,
                  config: _unref(formPreview),
                  defaults: _unref(colorDefaults).form,
                  elements: _unref(FORM_COLOR_ELEMENTS),
                  texts: FORM_TEXTS,
                  "wording-defaults": _unref(wordingDefaults),
                  hint: "Fonts follow your site. Click the title, the subtitle or the pencil by the button to change the wording.",
                  onEdit: _unref(applyEdit)
                }, null, 8, ["colors", "alignment", "script-url", "config", "defaults", "elements", "wording-defaults", "onEdit"])
              ]),
              _: 1
            }, 8, ["enabled", "live", "syncing", "snippet", "can-try", "pending-note"]),
            _createVNode(WebsiteChannel, {
              enabled: _unref(form).chat_enabled,
              "onUpdate:enabled": _cache[6] || (_cache[6] = $event => ((_unref(form).chat_enabled) = $event)),
              name: "Chat widget",
              description: "A chat bubble in the corner of your site. It asks the same questions in conversation, then hands over to your agent by text.",
              live: _unref(savedChatEnabled),
              syncing: _unref(syncing),
              snippet: _unref(websiteAttrs).chat_embed_snippet,
              "paste-guides": CHAT_PASTE_GUIDES,
              "can-try": _unref(testPageRevealed),
              "customize-label": "Preview and customize chat widget",
              benefits: CHAT_BENEFITS,
              "embed-label": "How to embed the chat widget in your site",
              "paste-note": "The bubble shows up on every page you add it to. Most people paste it once in the site footer.",
              "manual-note": "Paste this just before the closing </body> tag on every page.",
              "pending-note": pendingNotes.value.chat,
              "off-note": "Your chat widget is switched off, so visitors can't start a chat.",
              onTry: _cache[7] || (_cache[7] = $event => (openExample('chat')))
            }, {
              mini: _withCtx(() => [
                _createVNode(SiteMini, {
                  channel: "chat",
                  config: _unref(chatPreview),
                  "site-name": businessName.value,
                  defaults: _unref(colorDefaults).chat
                }, null, 8, ["config", "site-name", "defaults"])
              ]),
              report: _withCtx(() => [
                _createVNode(ChannelReportLink, {
                  summary: reportSummary.value?.chat,
                  days: reportSummary.value?.days,
                  to: _unref(websiteReportPath)(_unref(route).params.id, 'chat')
                }, null, 8, ["summary", "days", "to"])
              ]),
              extra: _withCtx(() => [
                _createVNode(SettingRow, {
                  label: "Opening line",
                  hint: "What the chat bot widget says first."
                }, {
                  default: _withCtx(() => [
                    _createVNode(InputField, {
                      modelValue: _unref(form).chat_opening_line,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_unref(form).chat_opening_line) = $event)),
                      name: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              customize: _withCtx(() => [
                _createVNode(ChannelDesigner, {
                  colors: _unref(form).chat_colors,
                  "onUpdate:colors": _cache[5] || (_cache[5] = $event => ((_unref(form).chat_colors) = $event)),
                  channel: "chat",
                  "script-url": _unref(websiteAttrs).chat_embed_script_url,
                  config: _unref(chatPreview),
                  defaults: _unref(colorDefaults).chat,
                  elements: _unref(CHAT_COLOR_ELEMENTS),
                  texts: CHAT_TEXTS,
                  "wording-defaults": _unref(wordingDefaults),
                  hint: "Click either line of the header to change it. Nothing you do here is sent anywhere.",
                  onEdit: _unref(applyEdit)
                }, null, 8, ["colors", "script-url", "config", "defaults", "elements", "wording-defaults", "onEdit"])
              ]),
              _: 1
            }, 8, ["enabled", "live", "syncing", "snippet", "can-try", "pending-note"]),
            _createVNode(SettingCard, {
              name: "Questions",
              description: "Asked by both the inquiry form and the chat widget. Drag to reorder."
            }, {
              action: _withCtx(() => [
                _createVNode(NeueButton, {
                  type: "secondary",
                  size: "sm",
                  onClick: _unref(addField)
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("+ Question", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "px-6 pb-4 text-sm text-gray-400" }, " Write them the way you would on a form. The form asks them word for word. The chat asks them in this same order, one at a time, in its own words. ", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    ref_key: "questionList",
                    ref: questionList,
                    class: "min-w-0"
                  }, [
                    (_unref(fields).length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          ref_key: "rows",
                          ref: rows,
                          class: "space-y-2"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.key
                            }, [
                              (_unref(editingKey) !== field.key)
                                ? (_openBlock(), _createBlock(QuestionCard, {
                                    key: 0,
                                    field: field,
                                    "type-label": _unref(typeLabel)(field.field_type),
                                    options: _unref(isSelect)(field) ? field.options : [],
                                    incomplete: !_unref(isComplete)(field),
                                    onEdit: $event => (editingKey.value = field.key),
                                    onRemove: $event => (_unref(removeField)(index)),
                                    "onUpdate:required": $event => (field.required = $event)
                                  }, null, 8, ["field", "type-label", "options", "incomplete", "onEdit", "onRemove", "onUpdate:required"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(InputField, {
                                        modelValue: field.label,
                                        "onUpdate:modelValue": $event => ((field.label) = $event),
                                        name: "Question"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(SelectInput, {
                                        modelValue: field.field_type,
                                        "onUpdate:modelValue": $event => ((field.field_type) = $event),
                                        name: "Answer type",
                                        options: _unref(TYPE_OPTIONS)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(InputField, {
                                        modelValue: field.purpose,
                                        "onUpdate:modelValue": $event => ((field.purpose) = $event),
                                        name: "What this is for",
                                        placeholder: "e.g. the name of the person we'll be texting",
                                        description: "Optional, and never shown to visitors. It tells the AI in your chat widget what you're really asking - worth a line when a label could be read two ways, like 'Name' meaning the contact or the event."
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    (_unref(isSelect)(field))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "mb-1 block text-sm font-medium text-gray-900" }, "Options", -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option, optionIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: optionIndex,
                                              class: "mb-1.5 flex gap-2"
                                            }, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": $event => ((field.options[optionIndex]) = $event),
                                                class: "flex-1 rounded-md border border-gray-300 px-2.5 py-1.5 text-sm"
                                              }, null, 8, _hoisted_16), [
                                                [_vModelText, field.options[optionIndex]]
                                              ]),
                                              _createElementVNode("button", {
                                                class: "p-1.5 text-gray-400 hover:text-red-600",
                                                onClick: _withModifiers($event => (field.options.splice(optionIndex, 1)), ["prevent"])
                                              }, [
                                                _createVNode(_unref(XMarkIcon), {
                                                  class: "h-4 w-4",
                                                  "aria-hidden": "true"
                                                })
                                              ], 8, _hoisted_17)
                                            ]))
                                          }), 128)),
                                          _createVNode(NeueButton, {
                                            type: "ghost",
                                            size: "sm",
                                            onClick: $event => (field.options.push(''))
                                          }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                              _createTextVNode("+ Option", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!_unref(isComplete)(field))
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Saves once it has its question text" + _toDisplayString(_unref(isSelect)(field) ? ' and at least one option' : '') + ". ", 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createVNode(RequiredSwitch, {
                                        required: field.required,
                                        "onUpdate:required": $event => (field.required = $event)
                                      }, null, 8, ["required", "onUpdate:required"]),
                                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "flex-1" }, null, -1)),
                                      _createElementVNode("button", {
                                        class: "text-sm text-red-600",
                                        onClick: _withModifiers($event => (_unref(removeField)(index)), ["prevent"])
                                      }, "Delete", 8, _hoisted_20),
                                      _createVNode(NeueButton, {
                                        type: "primary",
                                        size: "sm",
                                        onClick: _cache[8] || (_cache[8] = $event => (editingKey.value = null))
                                      }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                          _createTextVNode("Done", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                            ]))
                          }), 128))
                        ], 512))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, "No questions yet", -1)),
                          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " Start with the usual catering questions, then edit or delete what you don't need. ", -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-400" }, " Name · Event date · How many people · Delivery ZIP code · Dietary needs ", -1)),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(NeueButton, {
                              type: "primary",
                              onClick: _unref(addStarterQuestions)
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("Add starter questions", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(NeueButton, {
                              type: "secondary",
                              onClick: _unref(addField)
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("+ Question", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ])),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wide text-gray-500" }, "Always included", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "mt-0.5 text-xs text-gray-500" }, " The law says you need permission before texting someone, so these two are on every form and every chat. ", -1)),
                      _createElementVNode("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(FIXED_FIELDS.value, (fixed) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: fixed.label,
                            class: "flex items-start gap-2.5 py-2"
                          }, [
                            _createVNode(_unref(LockClosedIcon), {
                              class: "mt-0.5 h-3.5 w-3.5 shrink-0 text-gray-400",
                              "aria-hidden": "true"
                            }),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(fixed.label), 1),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(fixedMeta(fixed)), 1)
                            ]),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(fixed.type), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", null, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mb-2 flex items-center justify-center gap-2 text-xs text-gray-500" }, [
                      _createElementVNode("span", { class: "rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-600" }, " Preview "),
                      _createTextVNode(" Try it out - nothing you send here is submitted. ")
                    ], -1)),
                    (_unref(websiteAttrs).form_embed_script_url)
                      ? (_openBlock(), _createBlock(EmbedPreview, {
                          key: 0,
                          channel: "form",
                          "script-url": _unref(websiteAttrs).form_embed_script_url,
                          config: _unref(formPreview),
                          onEdit: _unref(applyEdit)
                        }, null, 8, ["script-url", "config", "onEdit"]))
                      : _createCommentVNode("", true),
                    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "mt-2.5 text-center text-xs text-gray-500" }, "What a visitor sees on your page", -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("p", { class: "mt-1 text-center text-xs leading-snug text-gray-400" }, " Your chat widget asks for the same things in its own words, so it won't read like this. ", -1))
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}